import React from "react";
import ReactDOM from "react-dom";
import { createRoot } from 'react-dom/client';
import "./index.css";
import App from "./App.tsx";
import reportWebVitals from "./reportWebVitals.js";
import { AppContextProvider } from "./context/AppContext.tsx";
// import { FileLibraryProvider } from "./context/FileLibraryContext";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ModalProvider, useModal } from "./context/ModalContext";

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <AppContextProvider>
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <ModalProvider>
        {/* <FileLibraryProvider> */}
          <App />
        {/* </FileLibraryProvider> */}
      </ModalProvider>
    </ThemeProvider>
  </AppContextProvider>)
;

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
